$(document).ready(function () {

    $('.js-carousel').initCycle({
        'slides': '> .js-c-slide',
        'pageActiveClass': 'active',
        'fx': 'carousel',
        'carousel-visible': 4,
        'carousel-fluid': true,
        'next': '.js-c-next',
        'prev': '.js-c-prev'
    });



});